// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"brands-home_wrapper__2cqgw","title":"brands-home_title__1KLYc","item":"brands-home_item__3GBqK"};